module.exports = __webpack_public_path__ + "static/media/ServiceFBET.adea4a91.jpg";